import axios from "axios";

export default {
  async getPersonsByStartName(startName, source) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        `/api/autocomplete/${source}/${startName}`
    );
    return response.data;
  }
};
